import React, { FC, ReactNode } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import ProgressBar from '../ProgressBar';
import * as S from './styles';

const msgs = defineMessages({
  current: {
    id: 'streaks_homepage_current',
    defaultMessage: 'Current',
  },
  longest: {
    id: 'streaks_homepage_longest',
    defaultMessage: 'Longest',
  },
  days: {
    id: 'streaks_celebration_days_web',
    defaultMessage:
      '{n, plural, one {<bold>#</bold> day} few {<bold>#</bold> days} many {<bold>#</bold> days} other {<bold>#</bold> days}}',
  },
});

export type StreakType = {
  current?: number;
  longest?: number;
  accomplishedToday?: boolean;
};

export const Streak: FC<StreakType> = ({ current = 0, longest = 0, accomplishedToday = false }) => {
  const intl = useIntl();
  const currentPercent = (current / longest) * 100 || 0;

  return (
    <S.Container data-testid="streak-info">
      <S.Label>{intl.formatMessage(msgs.current)}</S.Label>
      <S.Row>
        <S.Days $disabled={longest === 0 || current === 0}>
          {intl.formatMessage(msgs.days, {
            n: current,
            bold: (...chunks: ReactNode[]) => (
              <S.Number key={`number-${current}`} data-testid="current-streak-count">
                {chunks}
              </S.Number>
            ),
          })}
        </S.Days>
        <ProgressBar percentComplete={currentPercent} height="tiny" color="green" />
        {accomplishedToday ? <S.StreakIcon name="streak" /> : <S.NoStreakIcon name="noStreak" />}
      </S.Row>

      <S.Divider />
      <S.Label>{intl.formatMessage(msgs.longest)}</S.Label>
      <S.Row>
        <S.Days $disabled={longest === 0}>
          {intl.formatMessage(msgs.days, {
            n: longest,
            bold: (...chunks: ReactNode[]) => (
              <S.Number key={`number-${longest}`} data-testid="longest-streak-count">
                {chunks}
              </S.Number>
            ),
          })}
        </S.Days>
        <ProgressBar percentComplete={longest ? 100 : 0} height="tiny" color="green" />
        {accomplishedToday ? (
          <S.EmptyStreakIcon name="streak" />
        ) : (
          <S.EmptyNoStreakIcon name="noStreak" />
        )}
      </S.Row>
    </S.Container>
  );
};
